(function () {
  'use strict';

  angular
    .module('rosterChecking')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('rosterChecking', {
        url: '/roster-checking',
        views: {
          'rosterCheckingView': {
            templateUrl: 'roster-checking/views/roster-checking.tpl.html',
            controller: 'RosterCheckingCtrl',
            controllerAs: 'rosterChecking'
          }
        }
      });
  }
}());
